<div class="svg-container" [innerHTML]="svg | safeHtml" #svgContainer></div>
